import { render, staticRenderFns } from "./NewsSideBar.vue?vue&type=template&id=67ae4c7c&"
import script from "./NewsSideBar.vue?vue&type=script&lang=js&"
export * from "./NewsSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports